import { render, staticRenderFns } from "./LogoSection.vue?vue&type=template&id=3cb26879&scoped=true"
import script from "./LogoSection.vue?vue&type=script&lang=js"
export * from "./LogoSection.vue?vue&type=script&lang=js"
import style0 from "./LogoSection.vue?vue&type=style&index=0&id=3cb26879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb26879",
  null
  
)

export default component.exports